<template>
  <div class="d-flex">
    <div class="mr-8 responsive-lateral-menu" :class="{ 'is-mobile': $vuetify.display.mobile }" style="width: 250px; flex: 0 0 250px">
      <div class="overflow-y-auto overflow-x-hidden light-scrollbar overscroll-behavior-y-contain pr-2"
           style="position: fixed; top: 40px; bottom: 16px; width: 250px">
        <template v-if="! planningViewId">
          <div class="mb-1 font-weight-bold text-ellipsis">{{ $t('NAV.SHARE') }}</div>
          <tabs-vertical v-model="exportImportTabIndex" :mandatory="false">
            <v-tab value="share">
              <v-icon start>far fa-share-alt</v-icon>
              {{ $t('SHARE.CONTRIBUTORS') }}
            </v-tab>
            <v-tab v-if="hasReadOnlyLink" value="share-link">
              <v-icon start>far fa-link</v-icon>
              {{ $t('SHARE.INVITE_CUSTOMERS') }}
            </v-tab>
            <v-tab v-if="hasViews" value="share-views">
              <v-icon start>far fa-eye</v-icon>
              {{ $t('SHARE.CUSTOM_VIEWS') }}
            </v-tab>
          </tabs-vertical>
        </template>
        <div class="mt-4 mb-1 font-weight-bold text-ellipsis">{{ $t('NAV.EXPORT') }}</div>
        <tabs-vertical v-model="exportImportTabIndex" :mandatory="false">
          <v-tab value="export-image">
            <v-icon start>far fa-image</v-icon>
            {{ $t('EXPORT.IMAGE_EXPORT') }}
          </v-tab>
          <v-tab value="export-csv">
            <v-icon start>far fa-file-csv</v-icon>
            {{ $t('EXPORT.CSV_EXPORT') }}
          </v-tab>
        </tabs-vertical>
        <template v-if="! planningViewId">
          <div class="mt-4 mb-1 font-weight-bold text-ellipsis">{{ $t('NAV.IMPORT') }}</div>
          <tabs-vertical v-model="exportImportTabIndex" :mandatory="false">
            <v-tab value="import-template">
              <v-icon start>far fa-file-import</v-icon>
              {{ $t('PLANNING.IMPORT_TEMPLATE') }}
              <premium-section icon feature="import-template" class="ml-1"></premium-section>
            </v-tab>
            <v-tab value="import-csv">
              <v-icon start>far fa-file-csv</v-icon>
              {{ $t('IMPORT_CSV.CSV_IMPORT') }}
              <premium-section icon feature="import-csv" class="ml-1"></premium-section>
            </v-tab>
          </tabs-vertical>
        </template>
      </div>
    </div>

    <div class="flex-grow-1" style="min-width: 0">
      <!-- TAB SHARE -->
      <share-window v-if="section == 'share'" :planning="planning" :opened-tab-index="exportImportTabIndex" @close="close"></share-window>

      <!-- TAB EXPORT-->
      <keep-alive>
        <export-window v-if="section == 'export'" :planning="planning" :planning-view-id="planningViewId" :opened-tab-index="exportImportTabIndex" @close="close"></export-window>
      </keep-alive>

      <!-- TAB IMPORT TEMPLATE -->
      <premium-section v-if="exportImportTabIndex == 'import-template'" feature="import-template">
        <import-template :planning="planning" @close="close"></import-template>
      </premium-section>

      <keep-alive>
        <premium-section v-if="exportImportTabIndex == 'import-csv'" feature="import-csv">
          <import-csv :planning="planning" @close="close"></import-csv>
        </premium-section>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  import useUiPlanningStore from '@/stores/ui/planning';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import ShareWindow from '@/components/Share/ShareWindow.vue';
  import ExportWindow from './ExportWindow.vue';
  import ImportTemplate from './ImportTemplate.vue';
  import ImportCsv from './ImportCsv.vue';

  export default {
    components: {
      ShareWindow,
      ExportWindow,
      ImportTemplate,
      ImportCsv,
    },
    props: {
      planning: { type: Object, required: true },
      planningViewId: { type: Number, default: 0 },
    },
    data() {
      return {
        exportImportTabIndex: 'share',
        uiPlanningStore: useUiPlanningStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      section() {
        return (this.exportImportTabIndex || '').split('-')[0];
      },
      hasReadOnlyLink() { return ! this.usersAccessRightStore.config.hideExtenalLink; },
      hasViews() { return this.usersAccessRightStore.config.hasViews; },
    },
    watch: {
      'uiPlanningStore.exportImportOpeningTab': {
        handler(newVal) {
          if (newVal) this.exportImportTabIndex = newVal;
        },
        immediate: true,
      },
      exportImportTabIndex(newVal, oldVal) {
        if (! newVal && oldVal) this.exportImportTabIndex = oldVal; // prevent empty tab when clicking on selected tab
      },
    },
    methods: {
      close() {
        this.uiPlanningStore.openExportImport(null);
      },
    },
  };
</script>
